import { z } from 'zod';

import { LEDGER_ACCOUNT_SOURCE_TYPE, LEDGER_ACCOUNT_TYPE } from './constants';

export const zodLedgerAccountTypeSchema = z.enum(LEDGER_ACCOUNT_TYPE);

const zodLedgerAccountSourceTypeSchema = z.enum(LEDGER_ACCOUNT_SOURCE_TYPE);

/**
 * Minimal company reference embedded on a ledger account. Name and logo are
 * both optional on the wire, unlike the company-account reference below.
 */
const zodLedgerAccountCompanySchema = z.object({
  id: z.uuid(),
  logoUrl: z.string().nullish(),
  name: z.string().nullish(),
});

/**
 * Reference to the caller's own company account (the tenant owning the
 * ledger account), distinct from `company`, the specific company under that
 * account the account belongs to.
 */
const zodLedgerAccountCompanyAccountSchema = z.object({
  id: z.uuid(),
  name: z.string().nullable(),
});

/**
 * One effective-dated version of a ledger account.
 */
export const zodLedgerAccountSchema = z.object({
  accountCreatedOn: z.iso.datetime({ offset: true }),
  accountType: zodLedgerAccountTypeSchema,
  accountUpdatedBy: z.uuid().nullable(),
  accountUpdatedOn: z.iso.datetime({ offset: true }),
  company: zodLedgerAccountCompanySchema,
  companyAccount: zodLedgerAccountCompanyAccountSchema,
  costType: z.string().nullable(),
  createdBy: z.uuid(),
  createdOn: z.iso.datetime({ offset: true }),
  deletedAt: z.iso.datetime({ offset: true }).nullable(),
  deletedBy: z.uuid().nullable(),
  id: z.uuid(),
  isDeleted: z.boolean(),
  name: z.string(),
  number: z.string(),
  sourceType: zodLedgerAccountSourceTypeSchema,
  validFrom: z.iso.date(),
  versionId: z.uuid(),
});
